<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="file_026"></a><a id="page_11">3. Flat Shapes</a></h3><a id="page_11">
<p class="noindent">To make wings and ears, begin with a flat shape. Tear a piece of wool into smaller pieces and layer the pieces on the foam like a stack of pancakes <strong>(D)</strong>. Needle the surface. Gently remove the piece of wool from the foam and turn it over. Needle the other side <strong>(E)</strong>. Shape the flat piece by folding the sides in and needling <strong>(F)</strong>.</p>
<p class="image"><img alt="Image" src="images/f0011-01.jpg"/></p>
<p class="image"><img alt="Image" src="images/f0011-02.jpg"/></p>
<p class="image"><img alt="Image" src="images/f0011-03.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_026.vue?4212e227